import styled from 'styled-components';

export const Container = styled.div.attrs({})<{ hasIconsOnHover: any }>`
  .image-container::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 2;
  }

  .image-container:hover::after {
    background-color: ${(props) =>
      props.hasIconsOnHover ? 'rgba(0, 129, 198, 0.8)' : 'transparent'};
  }
`;
